export default __webpack_public_path__ + "static/giotto-4-3c8a9955240b64da0ad652ed889d0cd0.jpg";